<template>
  <div>
    <Head title="Payment Request Details" />
    <div class="flex items-center justify-between mb-6 mt-6 overflow-x-auto float-right">
      <div v-if="paymentRequest.payment_request_status_id === 1 && details.length">
        <a
          v-if="
            user.group_permissions.includes('create_payment_requisition') ||
            user.per_user_permissions.includes('create_payment_requisition')
          "
          class="btn-orange float-right"
          href="#"
          @click="openSendRequestPrompt()"
        >
          <span>Request</span>
        </a>
      </div>
      <div
        v-if="paymentRequest.payment_request_status_id === 2"
        class="flex items-end justify-end float-right space-x-3"
      >
        <button
          v-if="
            user.group_permissions.includes('approve_payment_requisition') ||
            user.per_user_permissions.includes('approve_payment_requisition')
          "
          type="button"
          class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-green-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-green sm:text-sm sm:leading-5"
          @click="openApprovePrompt()"
        >
          <span>Approve</span>
        </button>
        <button
          v-if="
            user.group_permissions.includes('reject_payment_requisition') ||
            user.per_user_permissions.includes('reject_payment_requisition')
          "
          type="button"
          class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-red-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-red-500 focus:outline-none focus:border-red-700 focus:shadow-outline-red sm:text-sm sm:leading-5"
          @click="openDeclinePrompt()"
        >
          <span>Decline</span>
        </button>
      </div>
      <div v-if="paymentRequest.status.name === 'Bill Posted'">
        <button
          id="dropdownDividerButton"
          data-dropdown-toggle="dropdownDivider"
          class="text-white btn-orange bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
          type="button"
        >
          Actions
          <svg
            class="w-2.5 h-2.5 ms-3 mx-1"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 10 6"
          >
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="m1 1 4 4 4-4"
            />
          </svg>
        </button>

        <!-- Dropdown menu -->
        <div
          id="dropdownDivider"
          class="z-10 hidden bg-white divide-y divide-gray-100 rounded-lg shadow w-44 dark:bg-gray-700 dark:divide-gray-600"
        >
          <ul
            class="py-2 text-sm text-gray-700 dark:text-gray-200"
            aria-labelledby="dropdownDividerButton"
          >
            <li>
              <a
                v-if="
                  user.group_permissions.includes('review_approved_prs') ||
                  user.per_user_permissions.includes('review_approved_prs')
                "
                href="#"
                class="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                @click="openSchedulePaymentPrompt()"
                >Schedule Payment</a
              >
            </li>
          </ul>
        </div>
      </div>
      <div v-if="paymentRequest.status.name === 'Scheduled for Prepayment' || paymentRequest.status.name === 'Partially Prepaid'">
        <button
          v-if="
            user.group_permissions.includes('schedule_payment_requisition') ||
            user.per_user_permissions.includes('schedule_payment_requisition')
          "
          type="button"
          class="inline-flex justify-center rounded-md border border-transparent px-4 py-2 bg-green-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-red-500 focus:outline-none focus:border-red-700 focus:shadow-outline-red sm:text-sm sm:leading-5 mr-1"
          @click="openMarkPrePaidPrompt()"
        >
          <span>Add Prepayment</span>
        </button>
        <button
          id="dropdownDividerButton"
          data-dropdown-toggle="dropdownDivider"
          class="text-white hidden btn-orange bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
          type="button"
        >
          Actions
          <svg
            class="w-2.5 h-2.5 ms-3 mx-1"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 10 6"
          >
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="m1 1 4 4 4-4"
            />
          </svg>
        </button>

        <!-- Dropdown menu -->
        <div
          id="dropdownDivider"
          class="z-10 hidden bg-white divide-y divide-gray-100 rounded-lg shadow w-44 dark:bg-gray-700 dark:divide-gray-600"
        >
          <ul
            class="py-2 text-sm text-gray-700 dark:text-gray-200"
            aria-labelledby="dropdownDividerButton"
          >
            <li>
              <a
                v-if="
                  user.group_permissions.includes('review_approved_prs') ||
                  user.per_user_permissions.includes('review_approved_prs')
                "
                href="#"
                class="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                @click="openPostPrePaymentPrompt()"
                >Post-Prepay</a
              >
            </li>
            <li>
              <a
                v-if="
                  user.group_permissions.includes('review_approved_prs') ||
                  user.per_user_permissions.includes('review_approved_prs')
                "
                href="#"
                class="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                @click="openCancelPaymentPrompt()"
                >Cancel</a
              >
            </li>
          </ul>
        </div>
      </div>

      <div v-if="paymentRequest.status.name === 'Prepaid'">
        <button
          id="dropdownDividerButton"
          data-dropdown-toggle="dropdownDivider"
          class="text-white btn-orange bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
          type="button"
        >
          Actions
          <svg
            class="w-2.5 h-2.5 ms-3 mx-1"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 10 6"
          >
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="m1 1 4 4 4-4"
            />
          </svg>
        </button>

        <!-- Dropdown menu -->
        <div
          id="dropdownDivider"
          class="z-10 hidden bg-white divide-y divide-gray-100 rounded-lg shadow w-44 dark:bg-gray-700 dark:divide-gray-600"
        >
          <ul
            class="py-2 text-sm text-gray-700 dark:text-gray-200"
            aria-labelledby="dropdownDividerButton"
          >
            <li>
              <a
                v-if="
                  user.group_permissions.includes('review_approved_prs') ||
                  user.per_user_permissions.includes('review_approved_prs')
                "
                href="#"
                class="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                @click="sendPrepaidBillPostPayment()"
                >Prepaid Bill Posted</a
              >
            </li>
            <li v-show="false">
              <a
                v-if="
                  user.group_permissions.includes('review_approved_prs') ||
                  user.per_user_permissions.includes('review_approved_prs')
                "
                href="#"
                class="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                @click="openCancelPaymentPrompt()"
                >Cancel</a
              >
            </li>
          </ul>
        </div>
      </div>

      <div v-if="paymentRequest.status.name === 'Approved'">
        <button
          id="dropdownDividerButton"
          data-dropdown-toggle="dropdownDivider"
          class="text-white btn-orange bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
          type="button"
        >
          Actions
          <svg
            class="w-2.5 h-2.5 ms-3 mx-1"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 10 6"
          >
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="m1 1 4 4 4-4"
            />
          </svg>
        </button>

        <!-- Dropdown menu -->
        <div
          id="dropdownDivider"
          class="z-10 hidden bg-white divide-y divide-gray-100 rounded-lg shadow w-44 dark:bg-gray-700 dark:divide-gray-600"
        >
          <ul
            class="py-2 text-sm text-gray-700 dark:text-gray-200"
            aria-labelledby="dropdownDividerButton"
          >
            <li>
              <a
                v-if="
                  user.group_permissions.includes('review_approved_prs') ||
                  user.per_user_permissions.includes('review_approved_prs')
                "
                href="#"
                class="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                @click="openPrepaymentPrompt()"
                >Scheduled for Prepayment</a
              >
            </li>
            <li>
              <a
                v-if="
                  user.group_permissions.includes('review_approved_prs') ||
                  user.per_user_permissions.includes('review_approved_prs')
                "
                href="#"
                class="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                @click="openPostpaymentPrompt()"
                >Bill Posted</a
              >
            </li>
            <li>
              <a
                v-if="
                  user.group_permissions.includes('review_approved_prs') ||
                  user.per_user_permissions.includes('review_approved_prs')
                "
                href="#"
                class="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                @click="openDeclinePrompt()"
                >Payment Declined</a
              >
            </li>
          </ul>
          <!--
          <div class="py-2">
            <a
              href="#"
              class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:hover:bg-gray-600 dark:text-gray-200 dark:hover:text-white"
              >Decline</a
            >
          </div>
          -->
        </div>

        <button
          v-show="false"
          v-if="
            user.group_permissions.includes('review_approved_prs') ||
            user.per_user_permissions.includes('review_approved_prs')
          "
          type="button"
          class="inline-flex justify-center rounded-md border border-transparent px-4 py-2 bg-green-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-red-500 focus:outline-none focus:border-red-700 focus:shadow-outline-red sm:text-sm sm:leading-5 mr-1"
          @click="openPrepaymentPrompt()"
        >
          <span>Prepayment</span>
        </button>
        <button
          v-show="false"
          v-if="
            user.group_permissions.includes('review_approved_prs') ||
            user.per_user_permissions.includes('review_approved_prs')
          "
          type="button"
          class="inline-flex justify-center rounded-md border border-transparent px-4 py-2 bg-green-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-red-500 focus:outline-none focus:border-red-700 focus:shadow-outline-red sm:text-sm sm:leading-5 mr-1"
          @click="openPostpaymentPrompt()"
        >
          <span>Postpayment</span>
        </button>
        <button
          v-show="false"
          v-if="
            user.group_permissions.includes('schedule_payment_requisition') ||
            user.per_user_permissions.includes('schedule_payment_requisition')
          "
          type="button"
          class="inline-flex justify-center rounded-md border border-transparent px-4 py-2 bg-green-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-red-500 focus:outline-none focus:border-red-700 focus:shadow-outline-red sm:text-sm sm:leading-5 mr-1"
          @click="openSchedulePaymentPrompt()"
        >
          <span>Schedule Payment</span>
        </button>
        <button
          v-show="false"
          v-if="
            user.group_permissions.includes('schedule_payment_requisition') ||
            user.per_user_permissions.includes('schedule_payment_requisition')
          "
          type="button"
          class="inline-flex justify-center rounded-md border border-transparent px-4 py-2 bg-red-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-red-500 focus:outline-none focus:border-red-700 focus:shadow-outline-red sm:text-sm sm:leading-5"
          @click="openDeclinePaymentPrompt()"
        >
          <span>Decline Payment</span>
        </button>
      </div>
      <div v-if="paymentRequest.payment_request_status_id === 5 || paymentRequest.payment_request_status_id === 13">
        <button
          v-if="
            user.group_permissions.includes('schedule_payment_requisition') ||
            user.per_user_permissions.includes('schedule_payment_requisition')
          "
          type="button"
          class="inline-flex justify-center rounded-md border border-transparent px-4 py-2 bg-green-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-red-500 focus:outline-none focus:border-red-700 focus:shadow-outline-red sm:text-sm sm:leading-5 mr-1"
          @click="openMarkPaidPrompt()"
        >
          <span>Add Payment</span>
        </button>
      </div>
    </div>
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-orange-600 hover:text-orange-500" href="/payment-requests">{{
        paymentRequest.payment_request_number
      }}</Link>
      <a
        v-if="paymentRequest.status.name === 'Created'"
        href="#"
        class="text-orange-600 hover:text-orange-500"
        @click="openEditPrompt()"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="w-6 h-6"
          style="display: inline !important"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L6.832 19.82a4.5 4.5 0 01-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 011.13-1.897L16.863 4.487zm0 0L19.5 7.125"
          />
        </svg>
      </a>
      <sup v-if="paymentRequest.status.name === 'Paid'">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="w-6 h-6 text-green-700 text-3xl"
          style="display: inline"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M9 12.75L11.25 15 15 9.75M21 12c0 1.268-.63 2.39-1.593 3.068a3.745 3.745 0 01-1.043 3.296 3.745 3.745 0 01-3.296 1.043A3.745 3.745 0 0112 21c-1.268 0-2.39-.63-3.068-1.593a3.746 3.746 0 01-3.296-1.043 3.745 3.745 0 01-1.043-3.296A3.745 3.745 0 013 12c0-1.268.63-2.39 1.593-3.068a3.745 3.745 0 011.043-3.296 3.746 3.746 0 013.296-1.043A3.746 3.746 0 0112 3c1.268 0 2.39.63 3.068 1.593a3.746 3.746 0 013.296 1.043 3.746 3.746 0 011.043 3.296A3.745 3.745 0 0121 12z"
          />
        </svg>
      </sup>
      <table class="mt-4">
        <tr>
          <td><h2 style="font-size: 20px">Date</h2></td>
          <td class="pl-5">
            <h2 style="font-size: 20px; font-weight: 400">:{{ paymentRequestDate }}</h2>
          </td>
        </tr>
        <tr>
          <td><h2 style="font-size: 20px">Supplier</h2></td>
          <td>
            <h2 class="pl-5" style="font-size: 20px; font-weight: 400">
              :{{ supplierName ? supplierName.name : "-" }}
            </h2>
          </td>
        </tr>
        <tr v-if="department">
          <td><h2 style="font-size: 20px">Department</h2></td>
          <td>
            <h2 class="pl-5" style="font-size: 20px; font-weight: 400">
              :{{ department ? department.name : "-" }}
            </h2>
          </td>
        </tr>
        <tr>
          <td><h2 style="font-size: 20px">Currency</h2></td>
          <td>
            <h2 class="pl-5" style="font-size: 20px; font-weight: 400">
              :{{ paymentRequest ? paymentRequest.currency : "-" }}
            </h2>
          </td>
        </tr>
      </table>
    </h1>
    <div class="mb-3">
      <Link href="/payment-requests" class="text-orange-600 hover:text-orange-500 mb-2">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="w-6 h-6 inline"
          style="display: inline !important"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18"
          />
        </svg>
        Back
      </Link>
    </div>
    <div class="flex items-center justify-between mb-6">
      <search-filter
        v-model="form.search"
        class="mr-4 w-full max-w-md hidden"
        @reset="reset"
      >
        <label class="block text-gray-700">Role:</label>
        <select class="form-select mt-1 w-full">
          <option :value="null" />
          <option />
        </select>
      </search-filter>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto mb-4">
      <div class="grid grid-cols-2 gap-4 p-5">
        <div class="pt-3">
          <h1 style="font-size: 20px; font-weight: bold">Items</h1>
        </div>
        <div v-if="paymentRequest.payment_request_status_id === 1">
          <a
            v-if="
              user.group_permissions.includes('create_payment_requisition') ||
              user.per_user_permissions.includes('create_payment_requisition')
            "
            class="btn-orange float-right"
            href="#"
            @click="submitNewPR"
          >
            <span>Add</span>
            <span class="hidden md:inline">&nbsp;Item</span>
          </a>
        </div>
      </div>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="pb-3 pt-3 px-2">B/L No</th>
          <th class="pb-3 pt-3 px-2">Budget Line Description</th>
          <th width="20%" class="pb-3 pt-3 px-2">Account</th>
          <th class="pb-3 pt-3 px-2">Memo</th>
          <th class="pb-3 pt-3 px-2 text-center">Quanity</th>
          <th class="pb-3 pt-3 px-2 text-center">Unit Price</th>
          <th class="pb-3 pt-3 px-2 text-center">Amount</th>
          <th class="pb-3 pt-3 px-2 text-center">Currency</th>
          <th class="pb-3 pt-3 px-2" colspan="2" />
        </tr>
        <tr
          v-for="pr in details"
          :key="pr.id"
          class="hover:bg-orange-100 focus-within:bg-gray-100"
        >
          <td class="border-t">
            <a
              href="#"
              class="flex items-center px-2 py-2"
              tabindex="-1"
              @click="submitNewPR"
            >
              {{ pr.budget_line_no }}
            </a>
          </td>
          <td class="border-t">
            <a
              href="#"
              class="flex items-center px-2 py-2"
              tabindex="-1"
              @click="submitNewPR"
            >
              {{ pr.budget_line_description }}
            </a>
          </td>
          <td class="border-t">
            <a
              href="#"
              :title="pr.account"
              class="flex items-center px-2 py-2"
              tabindex="-1"
              @click="submitNewPR"
            >
              {{ pr.account }}
            </a>
          </td>
          <td class="border-t">
            <a
              href="#"
              class="flex items-center px-2 py-2"
              tabindex="-1"
              @click="submitNewPR"
            >
              {{ pr.description }}
            </a>
          </td>
          <td class="border-t">
            <a
              href="#"
              class="flex items-center justify-center px-2 py-2"
              tabindex="-1"
              @click="submitNewPR"
            >
              {{ addCommas(pr.quantity) }}
            </a>
          </td>
          <td class="border-t">
            <a
              href="#"
              class="flex items-center justify-center px-2 py-2"
              tabindex="-1"
              @click="submitNewPR"
            >
              {{ addCommas(pr.price) }}
            </a>
          </td>
          <td class="border-t">
            <a
              href="#"
              class="flex items-center justify-center px-2 py-2"
              tabindex="-1"
              @click="submitNewPR"
            >
              {{ addCommas(pr.amount) }}
            </a>
          </td>
          <td class="border-t">
            <a
              href="#"
              class="flex items-center justify-center px-2 py-2"
              tabindex="-1"
              @click="submitNewPR"
            >
              {{ pr.currency }}
            </a>
          </td>
          <td class="w-px border-t">
            <a
              v-if="paymentRequest.payment_request_status_id === 1"
              href="#"
              class="flex items-center px-4"
              tabindex="-1"
              @click="submitNewPR"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="w-6 h-6"
                style="display: inline !important"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10"
                />
              </svg>
            </a>
          </td>
          <td class="w-px border-t">
            <a
              v-if="paymentRequest.payment_request_status_id === 1"
              href="#"
              class="flex items-center px-4"
              tabindex="-1"
              @click="removeItem(pr)"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="w-6 h-6"
                style="display: inline !important"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
                />
              </svg>
            </a>
          </td>
        </tr>
        <tr>
          <td class="px-1 py-1 border-t" colspan="5"></td>
          <td class="px-1 py-1 border-t">
            <p class="p-2">
            <strong>Total Amount</strong>
            </p>
          </td>
          <td class="border-t items-center justify-center px-2 py-2">
            <p class="p-2">
            <strong> {{ addCommas(paymentRequest.total_amount) }}
            </strong>
            </p>
          </td>
          <td class="border-t">
            <strong class="flex items-center justify-center px-2 py-2">{{ paymentRequest.currency }}</strong>
          </td>
        </tr>
        <tr v-if="details.length === 0">
          <td class="px-1 py-1 border-t" colspan="8"><p class="p-2">No data found</p></td>
        </tr>
      </table>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto mt-4">
      <div class="grid grid-cols-2 gap-4 p-5">
        <div class="pt-3">
          <h1 style="font-size: 20px; font-weight: bold">Attachments</h1>
        </div>
        <div>
          <a
            v-if="
              user.group_permissions.includes('create_payment_requisition') ||
              user.per_user_permissions.includes('create_payment_requisition')
            "
            class="btn-orange float-right"
            href="#"
            @click="openAttachmentWindow(paymentRequest)"
          >
            <span>Add</span>
            <span class="hidden md:inline">&nbsp;Attachment</span>
          </a>
        </div>
      </div>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto mt-3">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="pb-3 pt-3 px-2" width="1%">#</th>
          <th class="pb-3 pt-3 px-2">Attachment</th>
          <th class="pb-3 pt-3 px-2" />
        </tr>
        <tr
          v-for="(doc, index) in documents"
          :key="doc.id"
          class="hover:bg-orange-100 focus-within:bg-gray-100"
        >
          <td class="border-t" width="5%">
            <a
              href="#"
              class="flex items-center px-2 py-2"
              tabindex="-1"
              @click="editItem(pr)"
            >
              {{ index + 1 }}
            </a>
          </td>
          <td class="border-t" width="80%">
            
            <a
              v-if="doc.document_path && !doc.is_image"
              :href="`/storage/${doc.document_path}`"
              target="_blank"
              class="text-gray-700 hover:text-orange-700 text-md"
              >{{ doc.document_name }}</a
            >
            <a
              v-if="doc.is_image"
              href="#"
              class="text-gray-700 hover:text-orange-700 text-md"
              @click="openmPRModal(doc)"
            >
              {{ doc.document_name }}
            </a>
            <a
              v-if="!doc.document_path"
              href="#"
              class="flex items-center px-2 py-2"
              tabindex="-1"
              @click="editItem(pr)"
            >
              {{ doc.document_name }}
            </a>
          </td>
          <td class="border-t">
            <a
              v-if="paymentRequest.status.name === 'Created'"
              href="#"
              class="flex items-end justify-end px-4"
              tabindex="-1"
              @click="editAttachment(doc)"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="w-6 h-6"
                style="display: inline !important"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10"
                />
              </svg>
            </a>
          </td>
          <td class="border-t">
            <a
              v-if="paymentRequest.payment_request_status_id === 1"
              href="#"
              class="flex items-end justify-end px-4"
              tabindex="-1"
              @click="removeAttachment(doc)"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="w-6 h-6"
                style="display: inline !important"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
                />
              </svg>
            </a>
          </td>
        </tr>
        <tr v-if="documents.length === 0">
          <td class="px-1 py-1 border-t" />
          <td class="px-1 py-1 border-t"><p class="p-2">No data found</p></td>
        </tr>
      </table>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto mt-4">
      <div class="grid grid-cols-2 gap-4 p-5">
        <div class="pt-3">
          <h1 style="font-size: 20px; font-weight: bold">Payment History</h1>
        </div>
      </div>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto mt-3">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="pb-3 pt-3 px-2" width="1%">#</th>
          <th class="pb-3 pt-3 px-2">Date</th>
          <th class="pb-3 pt-3 px-2">Attachment</th>
          <th class="pb-3 pt-3 px-2 flex items-center justify-end">Amount {{ paymentRequest ? '('+paymentRequest.currency+')' : "-" }}</th>
        </tr>
        <tr
          v-for="(payment, index) in paymentRequestPayments"
          :key="payment.id"
          class="hover:bg-orange-100 focus-within:bg-gray-100"
        >
          <td class="border-t pb-3 pt-3 px-2" width="5%">
              {{ index + 1 }}
          </td>
          <td class="border-t pb-3 pt-3 px-2">
            {{ payment.date }}
          </td>
          <td class="border-t pb-3 pt-3 px-2">
            <a
              v-if="payment.document_path"
              :href="`/storage/${payment.document_path}`"
              target="_blank"
              class="text-gray-700 hover:text-orange-700 text-md"
              >{{ payment.document }}</a>
            <a
              v-if="payment.is_image"
              href="#"
              class="text-gray-700 hover:text-orange-700 text-md"
              @click="openmPRModal(payment)"
            >
            {{ doc.document_name }}
            </a>
            <a v-if="!payment.document_path" href="#" class="text-gray-700 hover:text-orange-700 text-md">
              {{ payment.document }}
            </a>
          </td>
          <td class="border-t pb-3 pt-3 px-2 flex items-center justify-end">
            {{ payment.amount }}
          </td>
        </tr>
        <tr class="text-left font-bold">
          <th class="pb-3 pt-3 px-2" colspan="3">Total</th>
          <th class="pb-3 pt-3 px-2 flex items-end justify-end"> {{ totalPayment }}</th>
        </tr>
        <tr v-if="paymentRequestPayments.length === 0">
          <td class="px-1 py-1 border-t" />
          <td class="px-1 py-1 border-t"><p class="p-2">No data found</p></td>
        </tr>
      </table>
    </div>
  </div>
  <div v-if="openSendRequest" class="fixed z-10 inset-0 overflow-y-auto">
    <div
      class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
    >
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75" />
      </div>
      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" />
      <div
        class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-headline"
      >
        <form>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex modal-wrapper">
            <h1 style="font-size: 24px">Payment Request</h1>
          </div>
          <div class="bg-white px-4 pt-0 pb-4 sm:p-6 sm:pb-4">
            <div class="mb-4">
              You are about to send an approval request, do you wish to continue?
            </div>
          </div>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
              <button
                type="button"
                class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-green-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-red sm:text-sm sm:leading-5"
                @click="sendRequest"
              >
                Yes
              </button>
            </span>
            <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
              <button
                type="button"
                class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5"
                @click="closeOpenPR"
              >
                No
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div v-if="isCreatePrItemOpen" class="fixed z-10 inset-0 overflow-y-auto">
    <div
      class="flex items-start justify-center min-h-screen px-4 pt-6 pb-10 text-center sm:block sm:p-0"
    >
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
      </div>
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen"></span>

      <div
        class="inline-block align-top bg-white rounded-lg text-left w-3/4 shadow-xl transform transition-all sm:my-8 sm:align-middle"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-headline"
      >
        <form>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex modal-wrapper">
            <h1 style="font-size: 24px">
              New PR #{{ paymentRequest.payment_request_number }} Item
            </h1>
          </div>
          <div class="grid grid-cols-1 gap-2 pr-8 pl-8 pt-3 pb-1">
            <div
              v-for="(prItem, iindex) in formData.prItems"
              :key="iindex"
              class="flex flex-wrap"
            >
              <text-input
                v-model="prItem.id"
                class="hidden"
              />
              <div class="pb-2 pr-6 w-3/12">
                <p class="mb-2">Budget Line:</p>
                <multiselect
                  id="budget"
                  v-model="prItem.budget"
                  placeholder="Search Budget"
                  :options="budgets"
                  :close-on-select="true"
                  :searchable="true"
                />
                <div
                  v-if="$page.props.errors[`prItems.${iindex}.budget`]"
                  class="form-error pb-1 pr-6 w-full lg:w-4/4 mb-2"
                >
                  {{ $page.props.errors[`prItems.${iindex}.budget`] }}
                </div>
              </div>
              <div class="pb-2 pr-6 w-5/12">
                <textarea-input
                  v-model="prItem.description"
                  class="pb-2"
                  label="Memo"
                >
                </textarea-input>
                <div
                  v-if="$page.props.errors[`prItems.${iindex}.description`]"
                  class="form-error pb-1 pr-6 w-full lg:w-4/4 mb-2"
                >
                  {{ $page.props.errors[`prItems.${iindex}.description`] }}
                </div>
              </div>
              <div class="pb-2 pr-6 w-1/12">
                <text-input
                  v-model="prItem.quantity"
                  class="pb-2"
                  label="Quantity"
                  @keyup="getTotal(iindex)"
                />
                <div
                  v-if="$page.props.errors[`prItems.${iindex}.quantity`]"
                  class="form-error pb-1 pr-6 w-full lg:w-4/4 mb-2"
                >
                  {{ $page.props.errors[`prItems.${iindex}.quantity`] }}
                </div>
              </div>
              <div class="pb-2 pr-6 w-1/12">
                <text-input
                  v-model="prItem.price"
                  class="pb-2"
                  label="Unit Price"
                  @keyup="getTotal(iindex)"
                />
                <div
                  v-if="$page.props.errors[`prItems.${iindex}.price`]"
                  class="form-error pb-1 pr-6 w-full lg:w-4/4 mb-2"
                >
                  {{ $page.props.errors[`prItems.${iindex}.price`] }}
                </div>
              </div>
              <div class="pb-2 pr-6 w-1/12">
                <text-input
                  v-model="prItem.amount"
                  class="pb-2"
                  label="Amount"
                />
              </div>
              <div class="pb-2 pr-6 w-1/12">
                <div class="flex items-center space-x-3">
                  <svg
                    v-show="formData.prItems.length > 1"
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-6 w-6 cursor-pointer text-red-500"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    stroke-width="2"
                    @click="removeOrderItem(iindex, formData.prItems)"
                  >
                    <path stroke-linecap="round" stroke-linejoin="round"
                      d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>

                  <svg
                    v-show="iindex === countOrders"
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-6 w-6 cursor-pointer text-green-500"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    stroke-width="2"
                    @click="addOrderItem"
                  >
                    <path stroke-linecap="round" stroke-linejoin="round"
                      d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
              </div>
            </div>
            <div class="flex justify-end w-full border-t pt-4">
              <p class="text-lg font-semibold">
                Total PR Amount: {{ paymentRequest.currency }}. {{ totalOrderAmount }}
              </p>
            </div>
          </div>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
              <button
                v-if="
                  user.group_permissions.includes('create_payment_requisition') ||
                  user.per_user_permissions.includes('create_payment_requisition')
                "
                type="button"
                class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-green-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-red sm:text-sm sm:leading-5"
                @click="savePRDetails"
              >
                Save
              </button>
            </span>
            <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
              <button
                type="button"
                class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5"
                @click="closeOpenPR"
              >
                Cancel
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div v-if="isEditPrItemOpen" class="fixed z-10 inset-0 overflow-y-auto">
    <div
      class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
    >
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75" />
      </div>
      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" />
      <div
        class="inline-block align-bottom bg-white rounded-lg text-left w-1/2 overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-headline"
      >
        <form>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex modal-wrapper">
            <h1 style="font-size: 24px">Update Item</h1>
          </div>
          <div class="bg-white px-4 pt-0 pb-4 sm:p-6 sm:pb-4">
            <div class="flex flex-wrap -mb-8 -mr-6 p-8">
              <div class="pb-2 pr-6 w w-full lg:w-full">
                <div>
                  <div
                    v-if="show"
                    class="flex items-center justify-between mb-8 w-full max-w-3xl bg-green-500 rounded"
                  >
                    <div class="flex items-center">
                      <svg
                        class="flex-shrink-0 ml-4 mr-2 w-4 h-4 fill-white"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                      >
                        <polygon points="0 11 2 9 7 14 18 3 20 5 7 18" />
                      </svg>
                      <div class="py-4 text-white text-sm font-medium">
                        Item updated successfully.
                      </div>
                    </div>
                    <button type="button" class="group mr-2 p-2" @click="show = false">
                      <svg
                        class="block w-2 h-2 fill-green-800 group-hover:fill-white"
                        xmlns="http://www.w3.org/2000/svg"
                        width="235.908"
                        height="235.908"
                        viewBox="278.046 126.846 235.908 235.908"
                      >
                        <path
                          d="M506.784 134.017c-9.56-9.56-25.06-9.56-34.62 0L396 210.18l-76.164-76.164c-9.56-9.56-25.06-9.56-34.62 0-9.56 9.56-9.56 25.06 0 34.62L361.38 244.8l-76.164 76.165c-9.56 9.56-9.56 25.06 0 34.62 9.56 9.56 25.06 9.56 34.62 0L396 279.42l76.164 76.165c9.56 9.56 25.06 9.56 34.62 0 9.56-9.56 9.56-25.06 0-34.62L430.62 244.8l76.164-76.163c9.56-9.56 9.56-25.06 0-34.62z"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
              <div class="pb-8 pr-6 w w-full lg:w-full">
                <p class="mb-2">Budget Line:</p>
                <multiselect
                  id="budget"
                  v-model="selectedBudget"
                  placeholder="Search Budget"
                  :options="budgets"
                  :close-on-select="true"
                  :searchable="true"
                  @search-change="onSearchBudgetsChange"
                  @input="onSelectedBudget"
                />
                <div
                  v-if="$page.props.errors && $page.props.errors.budget"
                  class="form-error pb-1 pr-6 w-full lg:w-4/4 mb-2"
                >
                  {{ $page.props.errors.budget }}
                </div>
              </div>
              <text-input
                v-model="formPrData.description"
                :error="formPrData.errors.description"
                class="pb-8 pr-6 w-full lg:w-full"
                label="Memo"
              />
              <text-input
                v-model="formPrData.quantity"
                class="pb-8 pr-6 w-1/3 lg:w-1/3"
                label="Quantity"
                :error="formPrData.errors.quantity"
                @keyup="getEditTotal"
              />
              <text-input
                v-model="formPrData.price"
                class="pb-8 pr-6 w-1/3 lg:w-1/3"
                label="Unit Price"
                :error="formPrData.errors.price"
                @keyup="getEditTotal"
              />
              <text-input
                v-model="formPrData.amount"
                class="pb-8 pr-6 w-1/3 lg:w-1/3"
                label="Amount"
              />
            </div>
          </div>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
              <button
                v-if="
                  user.group_permissions.includes('create_payment_requisition') ||
                  user.per_user_permissions.includes('create_payment_requisition')
                "
                type="button"
                class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-green-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-red sm:text-sm sm:leading-5"
                @click="updatePRDetails"
              >
                Update
              </button>
            </span>
            <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
              <button
                type="button"
                class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5"
                @click="closeOpenPR"
              >
                Cancel
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div v-if="openAttachment" class="fixed z-10 inset-0 overflow-y-auto">
    <div
      class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
    >
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75" />
      </div>
      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" />
      <div
        class="inline-block align-bottom bg-white rounded-lg text-left w-1/2 overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-headline"
      >
        <form enctype="multipart/form-data" @submit.prevent="store">
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex modal-wrapper">
            <h1 style="font-size: 24px">Attach Documents</h1>
          </div>
          <div class="bg-white px-4 pt-0 pb-4 sm:p-6 sm:pb-4">
            <div class="flex flex-wrap -mb-8 -mr-6 p-8">
              <div class="pb-8 pr-6 w w-full lg:w-full">
                <file-input
                  v-model="formDocument.document_path"
                  class="pb-1 pr-6 w-full lg:w-4/4"
                  type="file"
                  accept="application/pdf, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                  label="Payment Request Document"
                />
                <div
                  v-if="$page.props.errors"
                  class="form-error pb-1 pr-6 w-full lg:w-4/4 mb-2"
                >
                  {{ $page.props.errors.document_path }}
                </div>
              </div>
              <text-input
                v-model="formDocument.document_name"
                class="pb-8 pr-6 w-full lg:w-full"
                label="Document Name"
              />
            </div>
          </div>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
              <button
                v-if="
                  user.group_permissions.includes('create_payment_requisition') ||
                  user.per_user_permissions.includes('create_payment_requisition')
                "
                type="submit"
                class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-green-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-red sm:text-sm sm:leading-5"
                @click="attachDocument"
              >
                Attach file
              </button>
            </span>
            <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
              <button
                type="button"
                class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5"
                @click="closeAttachment"
              >
                Cancel
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div v-if="openDeclineRequest" class="fixed z-10 inset-0 overflow-y-auto">
    <div
      class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
    >
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75" />
      </div>
      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" />
      <div
        class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-headline"
      >
        <form>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex modal-wrapper">
            <h1 style="font-size: 24px">Decline Payment Request</h1>
          </div>
          <div class="bg-white px-4 pt-0 pb-4 sm:p-6 sm:pb-4">
            <div class="mb-4">
              You are about to decline payment request, do you wish to continue?
            </div>
          </div>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
              <button
                type="button"
                class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-green-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-red sm:text-sm sm:leading-5"
                @click="sendDeclineRequest"
              >
                Yes
              </button>
            </span>
            <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
              <button
                type="button"
                class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5"
                @click="closeDeclineRequest"
              >
                No
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div v-if="openApproveRequest" class="fixed z-10 inset-0 overflow-y-auto">
    <div
      class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
    >
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75" />
      </div>
      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" />
      <div
        class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-headline"
      >
        <form>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex modal-wrapper">
            <h1 style="font-size: 24px">Approve Payment Request</h1>
          </div>
          <div class="bg-white px-4 pt-0 pb-4 sm:p-6 sm:pb-4">
            <div class="mb-4">
              You are about to approve payment request, do you wish to continue?
            </div>
          </div>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
              <button
                type="button"
                class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-green-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-red sm:text-sm sm:leading-5"
                @click="sendApproveRequest"
              >
                Yes
              </button>
            </span>
            <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
              <button
                type="button"
                class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5"
                @click="closeApproveRequest"
              >
                No
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div v-if="openDeclinePayment" class="fixed z-10 inset-0 overflow-y-auto">
    <div
      class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
    >
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75" />
      </div>
      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" />
      <div
        class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-headline"
      >
        <form>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex modal-wrapper">
            <h1 style="font-size: 24px">Decline Payment Request</h1>
          </div>
          <div class="bg-white px-4 pt-0 pb-4 sm:p-6 sm:pb-4">
            <div class="mb-4">
              You are about to decline payment request, do you wish to continue?
            </div>
          </div>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
              <button
                type="button"
                class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-green-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-red sm:text-sm sm:leading-5"
                @click="sendDeclinePayment"
              >
                Yes
              </button>
            </span>
            <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
              <button
                type="button"
                class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5"
                @click="closeDeclinePayment"
              >
                No
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div v-if="openCancelPayment" class="fixed z-10 inset-0 overflow-y-auto">
    <div
      class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
    >
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75" />
      </div>
      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" />
      <div
        class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-headline"
      >
        <form>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex modal-wrapper">
            <h1 style="font-size: 24px">Cancel Payment Request</h1>
          </div>
          <div class="bg-white px-4 pt-0 pb-4 sm:p-6 sm:pb-4">
            <div class="mb-4">
              You are about to cancel payment request, do you wish to continue?
            </div>
          </div>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
              <button
                type="button"
                class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-green-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-red sm:text-sm sm:leading-5"
                @click="sendCancelPayment"
              >
                Yes
              </button>
            </span>
            <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
              <button
                type="button"
                class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5"
                @click="closeCancelPayment"
              >
                No
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div v-if="openPostPrePayment" class="fixed z-10 inset-0 overflow-y-auto">
    <div
      class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
    >
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75" />
      </div>
      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" />
      <div
        class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-headline"
      >
        <form>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex modal-wrapper">
            <h1 style="font-size: 24px">Post-PrePay Payment Request</h1>
          </div>
          <div class="bg-white px-4 pt-0 pb-4 sm:p-6 sm:pb-4">
            <div class="mb-4">
              You are about to post-prepay this payment request, do you wish to continue?
            </div>
          </div>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
              <button
                type="button"
                class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-green-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-red sm:text-sm sm:leading-5"
                @click="sendPostPrePayment"
              >
                Yes
              </button>
            </span>
            <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
              <button
                type="button"
                class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5"
                @click="closePostPrePayment"
              >
                No
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div v-if="openSchedulePayment" class="fixed z-10 inset-0 overflow-y-auto">
    <div
      class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
    >
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75" />
      </div>
      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" />
      <div
        class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-headline"
      >
        <form>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex modal-wrapper">
            <h1 style="font-size: 24px">Schedule for Payment</h1>
          </div>
          <div class="bg-white px-4 pt-0 pb-4 sm:p-6 sm:pb-4">
            <div class="mb-4">
              <text-input
                v-model="formData.payment_schedule_date"
                type="date"
                class="pb-4 pr-6 w-full lg:w-full"
                label="Scheduled Date"
              />
              <p v-if="$props.errors.payment_schedule_date">
                <small class="text-red-700">{{
                  $props.errors.payment_schedule_date
                }}</small>
              </p>
            </div>
            <div class="mb-4">
              You are about to schedule this request for payment, do you wish to continue?
            </div>
          </div>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
              <button
                type="button"
                class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-green-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-red sm:text-sm sm:leading-5"
                @click="sendScheduleForPayment"
              >
                Yes
              </button>
            </span>
            <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
              <button
                type="button"
                class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5"
                @click="closeSchedulePayment"
              >
                No
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div v-if="openPrePayment" class="fixed z-10 inset-0 overflow-y-auto">
    <div
      class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
    >
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75" />
      </div>
      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" />
      <div
        class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-headline"
      >
        <form>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex modal-wrapper">
            <h1 style="font-size: 24px">Schedule for Prepayment</h1>
          </div>
          <div class="bg-white px-4 pt-0 pb-4 sm:p-6 sm:pb-4">
            <div class="mb-4">
              <text-input
                v-model="formDataPrepayment.payment_schedule_date"
                type="date"
                class="pb-4 pr-6 w-full lg:w-full"
                label="Scheduled Date"
              />
              <p v-if="$props.errors.payment_schedule_date">
                <small class="text-red-700">{{
                  $props.errors.payment_schedule_date
                }}</small>
              </p>
            </div>
            <div class="mb-4">
              You are about to schedule this request to Prepayment, do you wish to continue?
            </div>
          </div>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
              <button
                type="button"
                class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-green-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-red sm:text-sm sm:leading-5"
                @click="sendScheduleForPrePayment"
              >
                Yes
              </button>
            </span>
            <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
              <button
                type="button"
                class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5"
                @click="closeScheduleForPrePayment"
              >
                No
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div v-if="openPostPayment" class="fixed z-10 inset-0 overflow-y-auto">
    <div
      class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
    >
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75" />
      </div>
      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" />
      <div
        class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-headline"
      >
        <form>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex modal-wrapper">
            <h1 style="font-size: 24px">Mark as Post</h1>
          </div>
          <div class="bg-white px-4 pt-0 pb-4 sm:p-6 sm:pb-4">
            <div class="mb-4">
              You are about to mark this request as Post, do you wish to continue?
            </div>
          </div>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
              <button
                type="button"
                class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-green-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-red sm:text-sm sm:leading-5"
                @click="sendScheduleForPostPayment"
              >
                Yes
              </button>
            </span>
            <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
              <button
                type="button"
                class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5"
                @click="closeScheduleForPostPayment"
              >
                No
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div v-if="openMarkPaid" class="fixed z-10 inset-0 overflow-y-auto">
    <div
      class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
    >
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75" />
      </div>
      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" />
      <div
        class="inline-block align-bottom bg-white w-full max-w-md max-h-full rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-headline"
      >
        <form enctype="multipart/form-data" @submit.prevent="store">
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex modal-wrapper">
            <h1 style="font-size: 24px">Add Payment</h1>
          </div>
          <div class="bg-white px-4 pt-0 pb-4 sm:p-6 sm:pb-4">
            <div class="mb-4">
              <div class="pb-0 pr-6 w w-full lg:w-full">
                <file-input
                  v-model="formPaymentDocument.document_path"
                  class="pb-1 w-full lg:w-4/4"
                  type="file"
                  accept="application/pdf, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                  label="Attachment"
                />
                <div
                  v-if="$page.props.errors"
                  class="form-error pb-1 pr-6 w-full lg:w-4/4 mb-0"
                >
                  {{ $page.props.errors.document_path }}
                </div>
              </div>
              <div class="pb-0 w w-full lg:w-full">
                <text-input
                  v-model="formPaymentDocument.document_name"
                  class="pb-0 pr-6 w-full lg:w-full"
                  label="Payment Reference"
                />
                <div
                  v-if="$page.props.errors"
                  class="form-error pb-1 pr-6 w-full lg:w-4/4 mb-0"
                >
                  {{ $page.props.errors.document_name }}
                </div>
              </div>
              <div class="pb-0 pr-6 w w-full lg:w-full">
                <text-input
                  v-model="formPaymentDocument.amount"
                  class="pb-0 w-full lg:w-full"
                  label="Amount"
                />
                <div
                  v-if="$page.props.errors"
                  class="form-error pb-1 pr-6 w-full lg:w-4/4 mb-0"
                >
                  {{ $page.props.errors.amount }}
                </div>
              </div>
              <div class="pb-0 pr-6 w w-full lg:w-full">
                <p class="mb-1">Actions:</p>
                <multiselect
                  id="payment_type"
                  v-model="formPaymentDocument.payment_type"
                  placeholder="Search Actions"
                  :options="paymentTypes"
                  :close-on-select="true"
                  :searchable="true"
                />
                <div
                  v-if="$page.props.errors"
                  class="form-error pb-1 pr-6 w-full lg:w-4/4 mb-2"
                >
                  {{ $page.props.errors.payment_type }}
                </div>
              </div>
            </div>
            <div v-show="false" class="mb-4">
              You are about to confirm this payment request as paid, do you wish to
              continue?
            </div>
          </div>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
              <button
                type="button"
                class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-green-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-red sm:text-sm sm:leading-5"
                @click="sendMarkPaymentRequestPaid"
              >
                Add
              </button>
            </span>
            <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
              <button
                type="button"
                class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5"
                @click="closeMarkPaymentRequestPaid"
              >
                Close
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div v-if="openMarkPrePaid" class="fixed z-10 inset-0 overflow-y-auto">
    <div
      class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
    >
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75" />
      </div>
      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" />
      <div
        class="inline-block align-bottom bg-white w-full max-w-md max-h-full rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-headline"
      >
        <form enctype="multipart/form-data" @submit.prevent="store">
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex modal-wrapper">
            <h1 style="font-size: 24px">Add PrePayment</h1>
          </div>
          <div class="bg-white px-4 pt-0 pb-4 sm:p-6 sm:pb-4">
            <div class="mb-4">
              <div class="pb-0 pr-6 w w-full lg:w-full">
                <file-input
                  v-model="formPrePaymentDocument.document_path"
                  class="pb-1 w-full lg:w-4/4"
                  type="file"
                  accept="application/pdf, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                  label="Attachment"
                />
                <div
                  v-if="$page.props.errors"
                  class="form-error pb-1 pr-6 w-full lg:w-4/4 mb-0"
                >
                  {{ $page.props.errors.document_path }}
                </div>
              </div>
              <div class="pb-0 w w-full lg:w-full">
                <text-input
                  v-model="formPrePaymentDocument.document_name"
                  class="pb-0 pr-6 w-full lg:w-full"
                  label="Payment Reference"
                />
                <div
                  v-if="$page.props.errors"
                  class="form-error pb-1 pr-6 w-full lg:w-4/4 mb-0"
                >
                  {{ $page.props.errors.document_name }}
                </div>
              </div>
              <div class="pb-0 pr-6 w w-full lg:w-full">
                <text-input
                  v-model="formPrePaymentDocument.amount"
                  class="pb-0 w-full lg:w-full"
                  label="Amount"
                />
                <div
                  v-if="$page.props.errors"
                  class="form-error pb-1 pr-6 w-full lg:w-4/4 mb-0"
                >
                  {{ $page.props.errors.amount }}
                </div>
              </div>
              <div class="pb-0 pr-6 w w-full lg:w-full">
                <p class="mb-1">Actions:</p>
                <multiselect
                  id="payment_type"
                  v-model="formPrePaymentDocument.payment_type"
                  placeholder="Search Actions"
                  :options="prePaymentTypes"
                  :close-on-select="true"
                  :searchable="true"
                />
                <div
                  v-if="$page.props.errors"
                  class="form-error pb-1 pr-6 w-full lg:w-4/4 mb-2"
                >
                  {{ $page.props.errors.payment_type }}
                </div>
              </div>
            </div>
            <div v-show="false" class="mb-4">
              You are about to confirm this payment request as paid, do you wish to
              continue?
            </div>
          </div>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
              <button
                type="button"
                class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-green-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-red sm:text-sm sm:leading-5"
                @click="sendMarkPrePaymentRequestPaid"
              >
                Add
              </button>
            </span>
            <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
              <button
                type="button"
                class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5"
                @click="closeMarkPrePaymentRequestPaid"
              >
                Close
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div v-if="openPrepaidBillPosted" class="fixed z-10 inset-0 overflow-y-auto">
    <div
      class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
    >
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75" />
      </div>
      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" />
      <div
        class="inline-block align-bottom bg-white w-full max-w-md max-h-full rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-headline"
      >
        <form enctype="multipart/form-data" @submit.prevent="store">
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex modal-wrapper">
            <h1 style="font-size: 24px">Prepaid Bill Posted</h1>
          </div>
          <div class="bg-white px-4 pt-0 pb-4 sm:p-6 sm:pb-4">
            <div class="mb-4">
              <div class="pb-0 pr-6 w w-full lg:w-full">
                <file-input
                  v-model="formPrePaymentDocument.document_path"
                  class="pb-1 w-full lg:w-4/4"
                  type="file"
                  accept="application/pdf, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                  label="Attachment"
                />
                <div
                  v-if="$page.props.errors"
                  class="form-error pb-1 pr-6 w-full lg:w-4/4 mb-0"
                >
                  {{ $page.props.errors.document_path }}
                </div>
              </div>
              <div class="pb-0 w w-full lg:w-full">
                <text-input
                  v-model="formPrePaymentDocument.document_name"
                  class="pb-0 pr-6 w-full lg:w-full"
                  label="Payment Reference"
                />
                <div
                  v-if="$page.props.errors"
                  class="form-error pb-1 pr-6 w-full lg:w-4/4 mb-0"
                >
                  {{ $page.props.errors.document_name }}
                </div>
              </div>
              <div class="pb-0 pr-6 w w-full lg:w-full">
                <text-input
                  v-model="formPrePaymentDocument.amount"
                  class="pb-0 w-full lg:w-full"
                  label="Amount"
                />
                <div
                  v-if="$page.props.errors"
                  class="form-error pb-1 pr-6 w-full lg:w-4/4 mb-0"
                >
                  {{ $page.props.errors.amount }}
                </div>
              </div>
              <div class="pb-0 pr-6 w w-full lg:w-full">
                <p class="mb-1">Actions:</p>
                <multiselect
                  id="payment_type"
                  v-model="formPrePaymentDocument.payment_type"
                  placeholder="Search Actions"
                  :options="prePaymentTypes"
                  :close-on-select="true"
                  :searchable="true"
                />
                <div
                  v-if="$page.props.errors"
                  class="form-error pb-1 pr-6 w-full lg:w-4/4 mb-2"
                >
                  {{ $page.props.errors.payment_type }}
                </div>
              </div>
            </div>
            <div v-show="false" class="mb-4">
              You are about to confirm this payment request as paid, do you wish to
              continue?
            </div>
          </div>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
              <button
                type="button"
                class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-green-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-red sm:text-sm sm:leading-5"
                @click="sendMarkPrePaymentRequestPaid"
              >
                Add
              </button>
            </span>
            <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
              <button
                type="button"
                class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5"
                @click="closeMarkPrePaymentRequestPaid"
              >
                Close
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div v-if="openEditPR" class="fixed z-10 inset-0 overflow-y-auto">
    <div
      class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
    >
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75" />
      </div>
      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" />
      <div
        class="inline-block align-bottom bg-white w-1/2 rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-headline"
      >
        <form>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex modal-wrapper">
            <h1 style="font-size: 20px">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="w-6 h-6"
                style="display: inline !important"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M18 18.72a9.094 9.094 0 003.741-.479 3 3 0 00-4.682-2.72m.94 3.198l.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0112 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 016 18.719m12 0a5.971 5.971 0 00-.941-3.197m0 0A5.995 5.995 0 0012 12.75a5.995 5.995 0 00-5.058 2.772m0 0a3 3 0 00-4.681 2.72 8.986 8.986 0 003.74.477m.94-3.197a5.971 5.971 0 00-.94 3.197M15 6.75a3 3 0 11-6 0 3 3 0 016 0zm6 3a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm-13.5 0a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z"
                />
              </svg>
              Update Payment Request
            </h1>
          </div>
          <div class="bg-white px-4 pt-0 pb-4 sm:p-6 sm:pb-4">
            <div class="mb-4">
              <form enctype="multipart/form-data" @submit.prevent="update">
                <div class="grid grid-cols-21 gap-0">
                  <div>
                    <text-input
                      v-model="formDataUpdate.date"
                      type="date"
                      :error="$props.errors.date"
                      class="w-full lg:w-full"
                      label="Date"
                    />
                  </div>
                </div>
                <div class="grid grid-cols-21 gap-0">
                  <div>
                    <p class="pb-1">Supplier:</p>
                    <multiselect
                      id="source"
                      v-model="formDataUpdate.supplier"
                      placeholder="Search supplier"
                      :options="suppliers"
                      :clear-on-select="false"
                      :preserve-search="true"
                      :searchable="true"
                      class="mt-1 w-full"
                      :close-on-select="true"
                      :create-option="true"
                      :error="$props.errors.supplier"
                      :style="
                        $props.errors.supplier
                          ? 'border: var(--ms-border-width,1px) solid var(--ms-border-color,red)'
                          : ''
                      "
                    />
                    <p v-if="$props.errors" class="text-red-700 pt-2">
                      <small>{{ $props.errors.supplier }}</small>
                    </p>
                  </div>
                </div>
                <div class="grid grid-cols-21 gap-0">
                  <div>
                    <p class="pb-1">Department:</p>
                    <multiselect
                      id="source"
                      v-model="formDataUpdate.department"
                      placeholder="Search department"
                      :options="departments"
                      :clear-on-select="false"
                      :preserve-search="true"
                      :searchable="true"
                      class="mt-1 w-full"
                      :close-on-select="true"
                      :create-option="true"
                      :error="$props.errors.department"
                      :style="
                        $props.errors.department
                          ? 'border: var(--ms-border-width,1px) solid var(--ms-border-color,red)'
                          : ''
                      "
                    />
                    <p v-if="$props.errors" class="text-red-700 pt-2">
                      <small>{{ $props.errors.department }}</small>
                    </p>
                  </div>
                </div>
                <div class="pb-8 pr-6 w w-full lg:w-full gap-0">
                  <p class="mb-2">Currency:</p>
                  <multiselect
                    id="currency"
                    v-model="formDataUpdate.currency"
                    placeholder="Search Currency"
                    :options="currencies"
                    :close-on-select="true"
                    :searchable="true"
                    @search-change="onSearchCurrencyChange"
                    @input="onSelectedCurrency"
                  />
                  <p v-if="$props.errors.currency">
                    <small class="text-red-700">{{ $props.errors.currency }}</small>
                  </p>
                </div>
              </form>
            </div>
          </div>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
              <button
                type="button"
                class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-green-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-red sm:text-sm sm:leading-5"
                @click="update"
              >
                Save
              </button>
            </span>
            <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
              <button
                type="button"
                class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5"
                @click="closeEditPrompt"
              >
                Close
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div v-if="askToRemoveItem" class="fixed z-10 inset-0 overflow-y-auto">
    <div
      class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
    >
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75" />
      </div>
      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" />
      <div
        class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-headline"
      >
        <form enctype="multipart/form-data" @submit.prevent="store">
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex modal-wrapper">
            <h1 style="font-size: 24px">Remove Item</h1>
          </div>
          <div class="bg-white px-4 pt-0 pb-4 sm:p-6 sm:pb-4">
            <div class="mb-4">
              You are about to remove a PR item, do you wish to continue?
            </div>
          </div>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
              <button
                type="button"
                class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-green-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-red sm:text-sm sm:leading-5"
                @click="submitRemoveItem"
              >
                Yes
              </button>
            </span>
            <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
              <button
                type="button"
                class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5"
                @click="closeRemoveItem"
              >
                No
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div v-if="askToRemoveAttachment" class="fixed z-10 inset-0 overflow-y-auto">
    <div
      class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
    >
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75" />
      </div>
      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" />
      <div
        class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-headline"
      >
        <form enctype="multipart/form-data" @submit.prevent="store">
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex modal-wrapper">
            <h1 style="font-size: 24px">Remove Item</h1>
          </div>
          <div class="bg-white px-4 pt-0 pb-4 sm:p-6 sm:pb-4">
            <div class="mb-4">
              You are about to remove an attachemnt, do you wish to continue?
            </div>
          </div>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
              <button
                type="button"
                class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-green-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-red sm:text-sm sm:leading-5"
                @click="submitRemoveAttachment"
              >
                Yes
              </button>
            </span>
            <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
              <button
                type="button"
                class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5"
                @click="closeRemoveAttachment"
              >
                No
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div v-if="isEditAttachment" class="fixed z-10 inset-0 overflow-y-auto">
    <div
      class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
    >
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75" />
      </div>
      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" />
      <div
        class="inline-block align-bottom bg-white rounded-lg text-left w-1/2 overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-headline"
      >
        <form enctype="multipart/form-data" @submit.prevent="store">
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex modal-wrapper">
            <h1 style="font-size: 24px">Edit - Attach Documents</h1>
          </div>
          <div class="bg-white px-4 pt-0 pb-4 sm:p-6 sm:pb-4">
            <div class="flex flex-wrap -mb-8 -mr-6 p-8">
              <div class="pb-8 pr-6 w w-full lg:w-full">
                <file-input
                  v-model="formDocument.document_path"
                  class="pb-1 pr-6 w-full lg:w-4/4"
                  type="file"
                  accept="application/pdf, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                  label="Payment Request Document"
                />
                <div
                  v-if="$page.props.errors"
                  class="form-error pb-1 pr-6 w-full lg:w-4/4 mb-2"
                >
                  {{ $page.props.errors.document_path }}
                </div>
              </div>
              <text-input
                v-model="formDocument.document_name"
                class="pb-8 pr-6 w-full lg:w-full"
                label="Document Name"
              />
            </div>
          </div>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
              <button
                v-if="
                  user.group_permissions.includes('create_payment_requisition') ||
                  user.per_user_permissions.includes('create_payment_requisition')
                "
                type="submit"
                class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-green-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-red sm:text-sm sm:leading-5"
                @click="submitUpdateAttachment"
              >
                Attach file
              </button>
            </span>
            <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
              <button
                type="button"
                class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5"
                @click="closeEditAttachment"
              >
                Cancel
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div v-if="isImageOpen" class="fixed z-10 inset-0 overflow-y-auto">
    <div
      class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
    >
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75" />
      </div>
      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" />
      <div
        class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-headline"
      >
        <form>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex modal-wrapper">
            <h1>View Attachment</h1>
          </div>
          <div class="bg-white px-4 pt-0 pb-4 sm:p-6 sm:pb-4">
            <div class="mb-4">
              <img :src="`/storage/${prObj.document_path}`" width="600" />
            </div>
          </div>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
              <button
                type="button"
                class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-green-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-red sm:text-sm sm:leading-5"
                @click="closeViewMpr"
              >
                Close
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import { Head, Link } from "@inertiajs/inertia-vue3";
import Icon from "@/Shared/Icon";
import pickBy from "lodash/pickBy";
import Layout from "@/Shared/Layout";
import throttle from "lodash/throttle";
import mapValues from "lodash/mapValues";
import SearchFilter from "@/Shared/SearchFilter";
import Pagination from "@/Shared/Pagination";
import Multiselect from "@vueform/multiselect";
import TextInput from "@/Shared/TextInput";
import TextareaInput from "@/Shared/TextareaInput";
import FileInput from "@/Shared/FileInput";
import { Dropdown, Ripple, initTWE } from "tw-elements";

export default {
  components: {
    Head,
    Icon,
    Link,
    SearchFilter,
    Pagination,
    Multiselect,
    TextInput,
    TextareaInput,
    FileInput,
    Dropdown,
    Ripple,
    initTWE,
  },
  layout: Layout,
  props: {
    filters: Object,
    details: {
      type: Array,
      default: () => [],
    },
    paymentRequest: Object,
    budgets: Object,
    suppliers: Object,
    departments: Object,
    department: Object,
    supplierName: Object,
    paymentRequestDate: String,
    documents: Array,
    currencies: Array,
    errors: Object,
    paymentTypes: Array,
    prePaymentTypes: Array,
    paymentRequestPayments: Object,
    totalPayment: String,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
      },
      formData: this.$inertia.form({
        payment_request_id: this.paymentRequest.id,
        prItems: this.details.length
        ? this.details.map(d => ({
            id: d.id ?? null,
            budget: d.budget_id ?? null,
            description: d.description ?? null,
            quantity: d.quantity ?? null,
            price: d.price ?? null,
            amount: d.amount ?? (d.quantity && d.price ? d.quantity * d.price : null),
          }))
        : [
            {
              id: null,
              budget: null,
              description: null,
              quantity: null,
              price: null,
              amount: null,
            },
          ],
      }),
      formPrData: this.$inertia.form({
        payment_request_id: this.paymentRequest.id,
        id: null,
        budget: null,
        description: null,
        quantity: null,
        price: null,
        amount: null,
      }),
      formDataPrepayment: {
        payment_schedule_date: null,
      },
      formDocument: {
        payment_request_id: this.paymentRequest.id,
        document_path: null,
        document_name: null,
      },
      formPaymentDocument: {
        payment_request_id: this.paymentRequest.id,
        document_path: null,
        document_name: null,
        amount: null,
        payment_type: null
      },
      formPrePaymentDocument: {
        payment_request_id: this.paymentRequest.id,
        document_path: null,
        document_name: null,
        amount: null,
        payment_type: null
      },
      selectedBudget: null,
      selectedSupplier: null,
      rolePermissions: {
        viewUsers: "view users",
      },
      formDataUpdate: {
        date: null,
        supplier: null,
        department: null,
        currency: null,
      },
      isCreatePrOpen: false,
      isCreatePrItemOpen: false,
      isEditPrItemOpen: false,
      openAttachment: false,
      openSendRequest: false,
      openDeclineRequest: false,
      openApproveRequest: false,
      openApprovePaymentRequest: false,
      openDeclinePaymentRequest: false,
      openDeclinePayment: false,
      openSchedulePayment: false,
      openMarkPaid: false,
      isImageOpen: false,
      prObj: null,
      selectedItem: null,
      show: false,
      openEditPR: false,
      askToRemoveItem: false,
      isEditAttachment: false,
      doc: [],
      askToRemoveAttachment: false,
      openPrePayment: false,
      openPostPayment: false,
      openPostPrePayment: false,
      openCancelPayment: false,
      openMarkPrePaid: false,
      openPrepaidBillPosted: false
    };
  },
  computed: {
    countOrders() {
      if (this.formData.prItems.length === 0) {
        return 0
      }
      return this.formData.prItems.length - 1
    },
    user() {
      return this.$inertia.page.props.auth.user;
    },
    totalOrderAmount() {
      const sum =  this.formData.prItems.reduce(
        (sum, item) => sum + Number(item.amount || 0),
        0
      );
      return sum.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get(
          `/payment-request/${this.paymentRequest.id}/payment-request-details`,
          pickBy(this.form),
          { preserveState: true }
        );
      }, 150),
    },
  },
  methods: {
    addCommas(value) {
      const num = Number(value) || 0;
      return num.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    reset() {
      this.form = mapValues(this.form, () => null);
    },
    addOrderItem(e) {
      e.preventDefault()
      this.formData.prItems.push({
        id: null,
        budget: null,
        description: null,
        quantity: null,
        price: null,
        amount: null,
      })
    },
    removeOrderItem(index, orders) {
      orders.splice(index, 1)
    },
    openCreateNewPr() {
      this.isCreatePrOpen = true;
      this.formData.description = null;
      this.selectedBudget = null;
      this.formData.quantity = null;
      this.formData.price = null;
      this.formData.amount = null;
      this.show = false;
    },
    closeOpenPR() {
      this.isCreatePrOpen = false;
      this.isCreatePrItemOpen = false;
      this.isEditPrItemOpen = false;
      this.openSendRequest = false;
      this.show = false;
    },
    submitNewPR() {
      this.isCreatePrItemOpen = true;
      this.formData.description = null;
      this.selectedBudget = null;
      this.formData.quantity = null;
      this.formData.price = null;
      this.formData.amount = null;
    },
    openmPRModal(data) {
      this.isImageOpen = true;
      this.prObj = data;
    },
    closeViewMpr() {
      this.isImageOpen = false;
    },
    savePRDetails() {
      this.formData._method = "post";
      this.$inertia.post(
        `/payment-request/${this.paymentRequest.id}/payment-request-details`,
        this.formData,
        {
          onSuccess: () => {
            this.show = true;
            this.isCreatePrItemOpen = false;
          },
        }
      );
    },
    updatePRDetails() {
      this.formPrData.budget = this.selectedBudget;
      this.$inertia.post(
        `/payment-request/${this.paymentRequest.id}/payment-request-details/${this.selectedItem}`,
        this.formPrData,
        {
          onSuccess: () => {
            this.show = true;
            this.isEditPrItemOpen = false;
          },
        }
      );
    },
    onSearchBudgetsChange: throttle(function (search) {
      this.$inertia.get(
        `/payment-request/${this.paymentRequest.id}/payment-request-details`,
        { search },
        {
          preserveState: true,
          preserveScroll: true,
          replace: true,
        }
      );
    }, 200),
    onSelectedBudget(budget, id) {
      this.formPrData.budget = budget;
      this.selectedBudget = budget;
    },
    onSearchSuppliersChange: throttle(function (search) {
      this.$inertia.get(
        `/payment-request/${this.paymentRequest.id}/payment-request-details`,
        { search },
        {
          preserveState: true,
          preserveScroll: true,
          replace: true,
        }
      );
    }, 200),
    editItem(item) {
      if (
        this.paymentRequest.payment_request_status_id === 1 ||
        this.paymentRequest.payment_request_status_id === 2
      ) {
        this.show = false;
        this.selectedItem = item.id;
        this.isEditPrItemOpen = true;
        this.formPrData.description = item.description;
        this.selectedBudget = item.budget_id;
        this.formPrData.quantity = item.quantity;
        this.formPrData.price = item.price;
        this.formPrData.amount = item.amount;
        this.formPrData._method = "put";
      }
    },
    editAttachment(item) {
      if (
        this.paymentRequest.payment_request_status_id === 1 ||
        this.paymentRequest.payment_request_status_id === 2
      ) {
        this.show = false;
        this.isEditAttachment = true;
        this.doc = item;
        this.formDocument.document_name = item.document_name;
      }
    },
    closeEditAttachment() {
      this.isEditAttachment = false;
    },
    removeAttachment(item) {
      if (
        this.paymentRequest.payment_request_status_id === 1 ||
        this.paymentRequest.payment_request_status_id === 2
      ) {
        this.show = false;
        this.doc = item;
        this.askToRemoveAttachment = true;
      }
    },
    removeItem(item) {
      if (
        this.paymentRequest.payment_request_status_id === 1 ||
        this.paymentRequest.payment_request_status_id === 2
      ) {
        this.show = false;
        this.selectedItem = item.id;
        this.askToRemoveItem = true;
      }
    },
    closeRemoveItem() {
      this.askToRemoveItem = false;
    },
    closeRemoveAttachment() {
      this.askToRemoveAttachment = false;
    },
    submitRemoveItem() {
      this.$inertia.delete(
        `/payment-request/${this.paymentRequest.id}/payment-request-details/${this.selectedItem}`
      );
      this.askToRemoveItem = false;
    },
    submitRemoveAttachment() {
      this.$inertia.delete(
        `/payment-request/${this.paymentRequest.id}/payment-request-documents/${this.doc.id}`
      );
      this.askToRemoveAttachment = false;
    },
    getEditTotal() {
      const qty = Number(this.formPrData.quantity) || 0;
      const price = Number(this.formPrData.price ) || 0;
      this.formPrData.amount = qty * price;
    },
    getTotal(index) {
      const item = this.formData.prItems[index];
      const qty = Number(item.quantity) || 0;
      const price = Number(item.price) || 0;
      this.formData.prItems[index].amount = qty * price;
    },
    openAttachmentWindow(item) {
      this.openAttachment = true;
      this.selectedItem = item;
    },
    closeAttachment() {
      this.openAttachment = false;
    },
    attachDocument() {
      this.formDocument._method = "post";
      this.$inertia.post(
        `/payment-request/${this.paymentRequest.id}/payment-request-documents`,
        this.formDocument,
        {
          onSuccess: () => {
            this.show = true;
            this.openAttachment = false;
            this.formDocument.document_path = null;
            this.formDocument.document_name = null;
          },
        }
      );
    },
    submitUpdateAttachment() {
      this.formDocument._method = "put";
      this.formDocument.payment_request_id = this.paymentRequest.id;
      this.$inertia.post(
        `/payment-request/${this.paymentRequest.id}/payment-request-documents/${this.doc.id}`,
        this.formDocument,
        {
          onSuccess: () => {
            this.show = true;
            this.isEditAttachment = false;
            this.formDocument.document_path = null;
            this.formDocument.document_name = null;
          },
        }
      );
    },
    openSendRequestPrompt() {
      this.openSendRequest = true;
    },
    sendRequest() {
      let requestForm = {};
      (requestForm.payment_request_id = this.paymentRequest.id),
        (requestForm._method = "post"),
        this.$inertia.post("/send-request", requestForm, {
          onSuccess: () => {
            this.show = true;
            this.openSendRequest = false;
          },
        });
    },
    openDeclinePrompt() {
      this.openDeclineRequest = true;
    },
    openApprovePrompt() {
      this.openApproveRequest = true;
    },
    closeApproveRequest() {
      this.openApproveRequest = false;
    },
    closeDeclineRequest() {
      this.openDeclineRequest = false;
    },
    openSchedulePaymentPrompt() {
      this.openSchedulePayment = true;
    },
    openPrepaymentPrompt() {
      this.openPrePayment = true;
    },
    openPrepaidBillPostedPrompt() {
      this.openPrepaidBillPosted = true;
    },
    openPostPrePaymentPrompt() {
      this.openPostPrePayment = true;
    },
    openPostpaymentPrompt() {
      this.openPostPayment = true;
    },
    openDeclinePaymentPrompt() {
      this.openDeclinePayment = true;
    },
    openCancelPaymentPrompt() {
      this.openCancelPayment = true;
    },
    openMarkPaidPrompt() {
      this.openMarkPaid = true;
    },
    openMarkPrePaidPrompt() {
      this.openMarkPrePaid = true;
    },
    sendDeclineRequest() {
      let requestForm = {};
      (requestForm.payment_request_id = this.paymentRequest.id),
        (requestForm._method = "post"),
        this.$inertia.post("/decline-request", requestForm, {
          onSuccess: () => {
            this.show = true;
            this.openDeclineRequest = false;
          },
        });
    },
    sendApproveRequest() {
      let requestForm = {};
      (requestForm.payment_request_id = this.paymentRequest.id),
        (requestForm._method = "post"),
        this.$inertia.post("/approve-request", requestForm, {
          onSuccess: () => {
            this.show = true;
            this.openApproveRequest = false;
          },
        });
    },
    closeSchedulePayment() {
      this.openSchedulePayment = false;
    },
    closeDeclinePayment() {
      this.openDeclinePayment = false;
    },
    closeCancelPayment() {
      this.openCancelPayment = false;
    },
    closePostPrePayment() {
      this.openPostPrePayment = false;
    },
    closeScheduleForPostPayment() {
      this.openPostPayment = false;
    },
    closeScheduleForPrePayment() {
      this.openPrePayment = false;
    },
    sendScheduleForPayment() {
      let requestForm = {};
      (requestForm.payment_request_id = this.paymentRequest.id),
        (requestForm.payment_schedule_date = this.formData.payment_schedule_date),
        (requestForm._method = "post"),
        this.$inertia.post("/schedule-payment-request", requestForm, {
          onSuccess: () => {
            this.show = true;
            this.openSchedulePayment = false;
          },
        });
    },
    sendScheduleForPrePayment() {
      let requestForm = {};
      (requestForm.payment_schedule_date = this.formDataPrepayment.payment_schedule_date),
      (requestForm.payment_request_id = this.paymentRequest.id),
        (requestForm._method = "post"),
        this.$inertia.post("/mark-schedule-prepayment-request", requestForm, {
          onSuccess: () => {
            this.show = true;
            this.openPrePayment = false;
          },
        });
    },
    sendPrepaidBillPostPayment() {
      let requestForm = {};
      if (confirm('Are you sure you want to post this payment request?')) {
      (requestForm.payment_request_id = this.paymentRequest.id),
        (requestForm._method = "post"),
        this.$inertia.post("/mark-prepaid-bill-post-payment-request", requestForm, {
          onSuccess: () => {
          },
        });
      }
    },
    sendScheduleForPostPayment() {
      let requestForm = {};
      (requestForm.payment_request_id = this.paymentRequest.id),
        (requestForm._method = "post"),
        this.$inertia.post("/mark-postpayment-request", requestForm, {
          onSuccess: () => {
            this.show = true;
            this.openPostPayment = false;
          },
        });
    },
    sendDeclinePayment() {
      let requestForm = {};
      (requestForm.payment_request_id = this.paymentRequest.id),
        (requestForm._method = "post"),
        this.$inertia.post("/decline-payment", requestForm, {
          onSuccess: () => {
            this.show = true;
            this.openDeclinePayment = false;
          },
        });
    },
    sendCancelPayment() {
      let requestForm = {};
      (requestForm.payment_request_id = this.paymentRequest.id),
        (requestForm._method = "post"),
        this.$inertia.post("/cancel-payment", requestForm, {
          onSuccess: () => {
            this.show = true;
            this.openCancelPayment = false;
          },
        });
    },
    sendPostPrePayment() {
      let requestForm = {};
      (requestForm.payment_request_id = this.paymentRequest.id),
        (requestForm._method = "post"),
        this.$inertia.post("/post-prepay-payment", requestForm, {
          onSuccess: () => {
            this.show = true;
            this.openPostPrePayment = false;
          },
        });
    },
    sendMarkPaymentRequestPaid() {
      if (this.formPaymentDocument.payment_type) {
          if (confirm(`Are you sure you want to mark this payment as a ${this.formPaymentDocument.payment_type}?`)) {
          let requestForm = {};
          (requestForm.payment_request_id = this.paymentRequest.id),
            (requestForm.document_path = this.formPaymentDocument.document_path),
            (requestForm.document_name = this.formPaymentDocument.document_name),
            (requestForm.amount = this.formPaymentDocument.amount),
            (requestForm.payment_type = this.formPaymentDocument.payment_type),
            (requestForm._method = "post"),
            this.$inertia.post("/mark-payment-request-paid", requestForm, {
              onSuccess: () => {
                this.show = true;
                this.openMarkPaid = false;
              },
            });
          }
        } else {
          alert('Please choose the payment type.')
        }
    },
    sendMarkPrePaymentRequestPaid() {
      if (this.formPrePaymentDocument.payment_type) {
          if (confirm(`Are you sure you want to mark this prepayment as a ${this.formPrePaymentDocument.payment_type}?`)) {
          let requestForm = {};
          (requestForm.payment_request_id = this.paymentRequest.id),
            (requestForm.document_path = this.formPrePaymentDocument.document_path),
            (requestForm.document_name = this.formPrePaymentDocument.document_name),
            (requestForm.amount = this.formPrePaymentDocument.amount),
            (requestForm.payment_type = this.formPrePaymentDocument.payment_type),
            (requestForm._method = "post"),
            this.$inertia.post("/mark-payment-request-prepaid", requestForm, {
              onSuccess: () => {
                this.show = true;
                this.openMarkPrePaid = false;
              },
            });
          }
        } else {
          alert('Please choose the prepayment type.')
        }
    },
    closeMarkPaymentRequestPaid() {
      this.openMarkPaid = false;
    },
    closeMarkPrePaymentRequestPaid() {
      this.openMarkPrePaid = false;
    },
    openEditPrompt() {
      this.openEditPR = true;
      this.formDataUpdate.id = this.paymentRequest.id;
      this.formDataUpdate.date = this.paymentRequest.payment_request_date;
      this.formDataUpdate.department = this.paymentRequest.payment_request_department;
      this.formDataUpdate.supplier = this.paymentRequest.payment_request_supplier;
      this.formDataUpdate.currency = this.paymentRequest.payment_request_currency;
    },
    closeEditPrompt() {
      this.openEditPR = false;
    },
    update() {
      (this.formDataUpdate.payment_request_id = this.paymentRequest.id),
        (this.formDataUpdate._method = "put"),
        this.$inertia.post(
          `/payment-requests/${this.paymentRequest.id}`,
          this.formDataUpdate,
          {
            onSuccess: () => {
              this.openEditPR = false;
            },
          }
        );
    },
  },
};
</script>

<style src="@vueform/multiselect/themes/default.css"></style>
<style type="text/css">
.multiselect-option.is-selected.is-pointed {
  background: var(--ms-option-bg-selected-pointed, #fb923c);
  color: var(--ms-option-color-selected-pointed, #fff);
}
.multiselect-option.is-selected {
  background: var(--ms-option-bg-selected-pointed, #fb923c);
  color: var(--ms-option-color-selected-pointed, #fff);
}
</style>
